const darkOverlay = {
    DarkOverlay: {
        baseStyle: () => ({
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                w: 'full',
                height: 'full',
                background: 'color.background.darkOverlay.default',
                zIndex: 'overlay',
            },
        }),
        variants: {
            headerMenu: {
                overlay: {
                    zIndex: 'dropdown',
                },
            },
        },
    },
}

export default darkOverlay
